import { useQuery } from "@tanstack/react-query";

export function GetPorcentajes() {
   const urlProd = process.env.REACT_APP_URL_DIR + "Porcentaje";
   const token = localStorage.getItem("token");
   return useQuery({
      queryKey: ["Porcentaje"],
      queryFn: () =>
         fetch(urlProd, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });
}



// export default GetPorcentajes;
